const getLocaleDirection = (locale: string): 'ltr' | 'rtl' => {
	try {
		return locale === 'fa' ? 'rtl' : 'ltr'
	} catch {
		return 'ltr'
	}
}

export default getLocaleDirection
